export const TEST_STAGES = {
  INSTRUCTIONS: 1,
  PRACTICE: 2,
  TERMS: 3,
  TEST_QUESTIONS: 4,
  SKIPPED_QUESTIONS: 5,
  REVIEW: 6,
  TEST_COMPLETE_RESULTS: 7,
};

export const TEST_STATUSES = {
  AUDIT: "A",
  CANCELLED: "C",
  COMPLETE: "F",
  NOT_STARTED: "N",
  PROGRESSING: "P",
  SUSPENDED: "S",
  PENDING_APPROVAL: "U",
};

export const ERRORS = {
  NO_SKIPPED_QUESTIONS: "NO_SKIPPED_QUESTION_FOUND",
};
